import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getSubscribeEmails } from "../api/ApiRoutesFile";

export const subscribeEmailApiSlice = createApi({
  reducerPath: "subscribeEmail",
  baseQuery: fetchBaseQuery({
    baseUrl: "https://castle-auction-production.up.railway.app/api/",
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      const token = localStorage.getItem("auction_portal");
      if (token) {
        headers.set("x-auth-token", token);
      }
      return headers;
    },
  }),
  tagTypes: ["SubscribeEmails"],
  endpoints: (builder) => ({
    subscribeEmails: builder.query({
      query: ({ endpoint, id }) => {
        const url = id ? `${endpoint}/${id}` : endpoint;
        return {
          url,
          method: "GET",
        };
      },
      providesTags: (result) =>
        result
          ? [
              ...result.lists.map(({ _id }) => ({
                type: "SubscribeEmails",
                id: _id,
              })),
              { type: "SubscribeEmails", id: "LIST" },
            ]
          : [{ type: "SubscribeEmails", id: "LIST" }],
    }),

    updateSubscribeEmail: builder.mutation({
      query: ({ endpoint, id, formData }) => ({
        url: `${endpoint}/${id}`,
        method: "PUT",
        body: formData,
      }),
      // Wait for API response before updating the cache
      async onQueryStarted(
        { endpoint, id, formData, lastId },
        { dispatch, queryFulfilled }
      ) {
        try {
          const { data } = await queryFulfilled; // wait for the API call to complete
          if (data && data.list) {
            // Update paginated cache if applicable
            dispatch(
              subscribeEmailApiSlice.util.updateQueryData(
                "lists",
                { endpoint: getSubscribeEmails, id: lastId },
                (draft) => {
                  const index = draft.lists.findIndex((a) => a._id === id);
                  if (index !== -1) {
                    draft.lists[index] = data.list;
                  }
                }
              )
            );
          }
        } catch (error) {
          console.error("Update failed:", error);
          // Handle rollback if needed
        }
      },
    }),
  }),
});

export const { useSubscribeEmailsQuery, useUpdateSubscribeEmailMutation } =
  subscribeEmailApiSlice;
